import type { ColumnDef } from '@tanstack/react-table';
import type { CustomerEntity } from 'services/openapi';
import { StringUtils } from 'modules';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'configs';

export type FilterType = {
  customerCode?: string;
  customerName?: string;
  customerPhoneNumber?: string;
  searchDetailContent?: string;
  refreshData: number;
  pageSize: number;
  pageIndex: number;
};

export const getInitFilterValues = (urlParams: any): FilterType => {
  return {
    refreshData: 0,
    customerCode: urlParams?.get('customerCode') ?? '',
    customerName: urlParams?.get('customerName') ?? '',
    searchDetailContent: urlParams?.get('searchDetailContent') ?? '',
    pageSize: Number(urlParams?.get('pageSize') ?? DEFAULT_PAGE_SIZE),
    pageIndex: Number(urlParams?.get('pageIndex') ?? DEFAULT_PAGE_INDEX),
  };
};

// export const initFilterValues: FilterType = {
//   refreshData: 0,
// };

export const columnsDefined: ColumnDef<CustomerEntity>[] = [
  {
    accessorKey: 'customerCode',
    header: 'Mã khách hàng',
  },
  {
    accessorKey: 'customerName',
    header: 'Tên khách hàng',
  },
  {
    accessorKey: 'customerPhoneNumber',
    header: 'Số điện thoại',
    cell: (info) =>
      info.getValue()
        ? StringUtils.normalizedPhoneNumber(info.getValue() as string)
        : '',
  },
  {
    accessorKey: 'customerAddress',
    header: 'Địa chỉ',
  },
  {
    accessorKey: 'customerEmail',
    header: 'Email',
  },
];

export const exportHeaders = [
  'STT',
  'Mã khách hàng',
  'Tên khách hàng',
  'Số điện thoại',
  'Địa chỉ',
  'Email',
];
